export class CerMarkdownPdf {

    public static async downloadPdf(div: HTMLDivElement, title: string, filename: string) {
        const JSpdf = typeof window !== 'undefined' ? (await import('jspdf')).jsPDF : null;
        if (JSpdf !== null) {
            const unit = 'pt';
            const size = 'A4';
            const orientation = 'portrait';

            const doc = new JSpdf(orientation, unit, size);
            doc.setFontSize(12);
            /*doc.content = {
                startY: 50,
                head: [title],
            };*/

            //html2canvas(div).then(function (canvas) {            
            //doc.addImage(img2, 'PNG', 10, 150, 190, 100);
            
            doc.html(div, {
                callback: function (doc: any) {
                    doc.save(filename + '.pdf');
                },
                margin: [10, 0, 10, 0],
                x: 10, // Adjust the left margin
                y: 1, // Adjust the top margin
                width: 190, // target width in the PDF document (210mm - 20mm total margins)
                windowWidth: 600, // window width in CSS pixels
                autoPaging: 'text',
                html2canvas: {
                    ignoreElements(el: HTMLElement) {
                        return typeof el.shadowRoot === 'object' && el.shadowRoot !== null;
                    },
                },
            });
        }
    }
}

